import { chunk } from 'lodash';
import { PosWaypoint } from 'gl-ms-positions';

const RADIUS: any = {
    1: 70000, 2: 70000, 3: 30000, 4: 30000, 5: 30000, 6: 30000, 7: 5000, 8: 5000, 9: 5000, 10: 3000, 11: 3000, 12: 2000, 13: 2000, 14: 1000, 15: 1000, 16: 1000, 17: 1000, 18: 500, 19: 500, 20: 5, 21: 1, 22: 1, 23: 1,
};

/**
 * This function returns the index I of the closest element in the
 * route
 * @param singlePoint
 * @param latLngAltArray
 */
const calcualteMarkerPosition = (singlePoint: H.geo.Point, latLngAltArray: number[]): number => {
    let currentIndex = 0;
    const points: number[][] = chunk(latLngAltArray, 3);

    let savedDistance = 99999999;
    points.forEach((item: number[], index: number) => {
        const distance: number = singlePoint.distance({
            lat: item[0],
            lng: item[1],
        });
        if (distance < savedDistance) {
            savedDistance = distance;
            currentIndex = index;
        }
    });

    return currentIndex;
};

/**
 * This function returns the position of one single point compared to the others given in input
 * @param point
 * @param trace
 * @param markers
 */
export const getSingleMarkerPosition = (point: any, trace: number[], markers: PosWaypoint[]): number => {
    let result = -1;
    const pointPosition: number = calcualteMarkerPosition(new H.geo.Point(point.lat, point.lng), trace);

    markers.some((item: any, index: number) => {
        const currentMarkerPosition: number = calcualteMarkerPosition(new H.geo.Point(item.geometry.coordinates[1], item.geometry.coordinates[0]),
            trace);
        if (pointPosition < currentMarkerPosition) {
            result = index;
            return true;
        }

        return false;
    });

    return result > 0 ? result : markers.length;
};

export const zoomToRadius = (zoom: number): number => RADIUS[zoom];
